/**
 * The CNP check digit, in the browser — so the warning appears while somebody
 * is typing rather than after they press submit.
 *
 * This duplicates `backend/services/ministry/cnp.py`. That is deliberate and
 * it is the smaller cost: a round-trip per keystroke to avoid twelve lines of
 * arithmetic would be worse, and this half only ever produces a warning —
 * whether a submission is accepted is decided by the backend alone, so the two
 * cannot disagree about anything that matters.
 *
 * Both copies are tested against the same numbers, so a change to one that is
 * not made to the other fails on that side.
 *
 * The check digit is a warning and never a block. It catches every mistyped
 * digit and nearly every transposition — but CNPs issued in the late 1970s are
 * reported to exist with incorrect check digits from administrative errors,
 * and those would belong to exactly the long-serving teachers this course is
 * for. So it tells people, and lets them through.
 */

const CHECK_WEIGHTS = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];

export const CNP_LENGTH = 13;

export const WARN_CHECKSUM =
  "CNP-ul pare introdus greșit. Verifică cifrele — dacă este corect, poți continua.";

export function checkDigit(firstTwelve) {
  const total = CHECK_WEIGHTS.reduce(
    (sum, weight, i) => sum + Number(firstTwelve[i]) * weight, 0,
  );
  const remainder = total % 11;
  return remainder === 10 ? 1 : remainder;
}

/**
 * `true` / `false` once thirteen digits are present, `null` before that.
 *
 * `null` means "say nothing yet": every keystroke of a half-typed number would
 * otherwise fail, and telling somebody their CNP looks wrong while they are
 * still on the fourth digit is just noise.
 */
export function checksumMatches(value) {
  const raw = String(value || "").trim();
  if (raw.length !== CNP_LENGTH || !/^\d+$/.test(raw)) return null;
  return Number(raw[12]) === checkDigit(raw.slice(0, 12));
}
